import '../css/quote.css';

const Quotes = () => (
  <div className="d-flex align-items-center justify-content-center height">
    <blockquote className="blockquote text-right">
      <p>
        Mathematics is not about numbers, equations, computations,
        or algorithms: it is about understanding
      </p>
      <footer className="blockquote-footer text-white">
        <cite title="Source Title">William Paul Thurston</cite>
      </footer>
    </blockquote>
  </div>
);

export default Quotes;
